import SettingsForm from 'CampaignBuilder/components/Steps/Settings/SettingsForm'
import Step from './Step'
import validateSettings from 'CampaignBuilder/validateSettings'

function SettingsShortDescriptor({ settings, validationErrors }) {
  const { settingsMode, testMode, testSizePerVariant, limitTotalMessages } = settings

  const settingsMessages = []
  if ( testMode === 'ab') {
    if (testSizePerVariant) {
      settingsMessages.push(<div>This campaign is in <strong>A/B test mode</strong> with <strong>{parseInt(testSizePerVariant).toLocaleString()}</strong> messages per version.</div>)
    } else {
      settingsMessages.push(<div>This campaign is in <strong>A/B test mode</strong>, but you need to set a test size to be able to see a count and send.</div>)
    }
  }

  if (limitTotalMessages === 'on') {
    settingsMessages.push(<div>This campaign has a <strong>limit on total messages</strong> of <strong>{parseInt(settings.maxTotalMessages).toLocaleString()}</strong>.</div>)
  }

  return (
    <div>
      <div>
        { settingsMessages.map((message, index) => message) }
        { settingsMessages.length === 0 && validationErrors.length === 0 && <div>Here you can change additional campaign settings</div> }
      </div>
      <div>
        { validationErrors.length > 0 && <p className='error no-margin-bottom'>You have {validationErrors.length} validation error{validationErrors.length > 1 ? 's' : ''} in your settings:</p> }
        { validationErrors.map((error, index) => <p key={index} className='error no-margin-bottom'>{error}</p>) }
      </div>
    </div>
  )
}

const Settings = () => {
  const { settings, campaignType } = useSel((s) => s.campaign)
  const validationErrors = validateSettings(settings, campaignType)

  return <Step
    name='Settings'
    editor='settings'
    complete={true}
    shortDescriptor={ <SettingsShortDescriptor settings={settings} validationErrors={validationErrors} /> }
    canClickFinish={validationErrors.length === 0}
    validationErrors={validationErrors}
  >
    <SettingsForm />
  </Step>
}

export default Settings
